export class UserRepository {

    static get() {
        return JSON.parse(localStorage.getItem("user"));
    }

    static delete() {
        return localStorage.removeItem("user")
    }

    static saveUser(user) {
        localStorage.setItem("user", JSON.stringify(user))
    }

    static saveUserToken(token) {
        localStorage.setItem("pwa_token", token)
    }

    static getUserToken() {
       return  localStorage.getItem("pwa_token")
    }
}
